// // import { useState, useEffect } from 'react';
// // import '../styles/home.scss';

// // import Slide1 from '../assets/slider/home1-slider1.webp';
// // import Slide2 from '../assets/slider/home1-slider2.webp';
// // import Slide3 from '../assets/slider/home1-slider3.webp';

// // const slides = [
// //   {
// //     image: Slide1,
// //     heading: 'Empowering Kenya’s Makers. Inspiring the World.',
// //     text: 'Discover authentic craftsmanship from Kenya’s finest artisans — verified, skilled, and ready to transform your space.',
// //     align: 'left',
// //     button: 'Explore Artisans | Join as a Maker',
// //     link: '/login',
// //   },
// //   {
// //     image: Slide2,
// //     heading: 'Where Craft Meets Technology.',
// //     text: 'Experience the future of craftsmanship — AI smart matching, AR visualization, and human stories that build trust.',
// //     align: 'right',
// //     button: 'Start Your Project',
// //     link: '/login',
// //   },
// //   {
// //     image: Slide3,
// //     heading: 'Behind Every Masterpiece is a Maker.',
// //     text: 'From handmade furniture to home finishing — connect with real artisans, discover their stories, and bring your vision to life.',
// //     align: 'right',
// //     button: 'Start Your Project',
// //     link: '/register',
// //   },
// // ];

// // export default function HeroSection() {
// //   const [currentIndex, setCurrentIndex] = useState(0);

// //   useEffect(() => {
// //     const timer = setInterval(() => {
// //       setCurrentIndex((prev) => (prev + 1) % slides.length);
// //     }, 6000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   return (
// //     <section className="hero-section">
// //       {slides.map((slide, index) => (
// //         <div
// //           key={index}
// //           className={`hero-slide ${index === currentIndex ? 'active' : ''}`}
// //           style={{ backgroundImage: `url(${slide.image})` }}
// //         >
// //           <div className="overlay"></div>

// //           <div
// //             className={`content-container container ${
// //               slide.align === 'left' ? 'align-left' : 'align-right'
// //             }`}
// //           >
// //             <p className="subtitle">New Collection</p>
// //             <h1>{slide.heading}</h1>
// //             <p className="description">{slide.text}</p>
// //             {slide.button && (
// //               <a
// //                 href={slide.link}
// //                 className="btn btn-light px-4 py-2 fw-semibold hero-btn"
// //               >
// //                 {slide.button}
// //               </a>
// //             )}
// //           </div>
// //         </div>
// //       ))}
// //     </section>
// //   );
// // }
// import { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import '../styles/home.scss';

// import Slide1 from '../assets/slider/home1-slider1.webp';
// import Slide2 from '../assets/slider/home1-slider2.webp';
// import Slide3 from '../assets/slider/home2-slider2.webp';

// const slides = [
//   {
//     image: Slide1,
//     heading: 'Empowering Kenya’s Makers. Inspiring the World.',
//     text: 'Discover authentic craftsmanship from Kenya’s finest artisans — from custom-made furniture to ready-made products, all verified and ready to transform your space.',
//     align: 'left',
//     customButton: {
//       text: 'Request Custom Work',
//       link: '/client-dashboard',
//       icon: '🎨'
//     },
//     readyButton: {
//       text: 'Browse Ready-Made',
//       link: '/ready-made-products',
//       icon: '🛍️'
//     },
//     showBothButtons: true
//   },
//   {
//     image: Slide2,
//     heading: 'Custom Projects or Ready-Made? We Got You.',
//     text: 'Choose your path: Commission unique custom furniture designed just for you, or shop from our collection of ready-made products available for immediate delivery.',
//     align: 'right',
//     customButton: {
//       text: 'Start Custom Project',
//       link: '/client-dashboard',
//       icon: '✏️'
//     },
//     readyButton: {
//       text: 'Shop Now',
//       link: '/ready-made-products',
//       icon: '🛒'
//     },
//     showBothButtons: true
//   },
//   {
//     image: Slide3,
//     heading: 'Behind Every Masterpiece is a Maker.',
//     text: 'Connect with skilled artisans for custom furniture projects, or discover their ready-made creations. From concept to completion, bring your vision to life.',
//     align: 'right',
//     customButton: {
//       text: 'Find an Artisan',
//       link: '/login',
//       icon: '👥'
//     },
//     readyButton: {
//       text: 'Shop Ready-Made',
//       link: '/ready-made-products',
//       icon: '🏪'
//     },
//     showBothButtons: true
//   },
// ];

// export default function HeroSection() {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % slides.length);
//     }, 6000);
//     return () => clearInterval(timer);
//   }, []);

//   useEffect(() => {
//     // Check if user is logged in
//     const token = localStorage.getItem('access_token');
//     setIsLoggedIn(!!token);
//   }, []);

//   return (
//     <section className="hero-section">
//       {slides.map((slide, index) => (
//         <div
//           key={index}
//           className={`hero-slide ${index === currentIndex ? 'active' : ''}`}
//           style={{ backgroundImage: `url(${slide.image})` }}
//         >
//           <div className="overlay"></div>

//           <div
//             className={`content-container container ${
//               slide.align === 'left' ? 'align-left' : 'align-right'
//             }`}
//           >
//             <p className="subtitle">Welcome to Artiza</p>
//             <h1>{slide.heading}</h1>
//             <p className="description">{slide.text}</p>
            
//             {slide.showBothButtons ? (
//               <div className="button-group">
//                 <Link
//                   to={slide.customButton.link}
//                   className="btn btn-outline-light px-4 py-2 fw-semibold hero-btn custom-btn"
//                 >
//                   <span className="btn-icon">{slide.customButton.icon}</span>
//                   {slide.customButton.text}
//                 </Link>
//                 <Link
//                   to={slide.readyButton.link}
//                   className="btn btn-light px-4 py-2 fw-semibold hero-btn ready-btn"
//                 >
//                   <span className="btn-icon">{slide.readyButton.icon}</span>
//                   {slide.readyButton.text}
//                 </Link>
//               </div>
//             ) : (
//               <a
//                 href={slide.link}
//                 className="btn btn-light px-4 py-2 fw-semibold hero-btn"
//               >
//                 {slide.button}
//               </a>
//             )}
//           </div>
//         </div>
//       ))}
//     </section>
//   );
// }

import { Link } from 'react-router-dom';
import '../styles/home.scss';

import Slide1 from '../assets/slider/home1-slider1.webp';

export default function HeroSection() {
  const slide = {
    image: Slide1,
    heading: 'Build With Confidence',
    text: 'Discover authentic craftsmanship from Kenya’s finest makers — from custom-made pieces to ready-made products.',
    align: 'left',
    customButton: {
      text: 'Request Custom Work',
      link: '/client-dashboard',
      icon: '🎨'
    },
    readyButton: {
      text: 'Browse Ready-Made',
      link: '/ready-made-products',
      icon: '🛍️'
    }
  };

  return (
    <section className="hero-section">
      <div
        className="hero-slide active"
        style={{ backgroundImage: `url(${slide.image})` }}
      >
        <div className="overlay"></div>

        <div
          className={`content-container container ${
            slide.align === 'left' ? 'align-left' : 'align-right'
          }`}
        >
          <p className="subtitle">Welcome to Artiza</p>
          <h1>{slide.heading}</h1>
          <p className="description">{slide.text}</p>

          <div className="button-group">
            <Link
              to={slide.customButton.link}
              className="btn btn-outline-light px-4 py-2 fw-semibold hero-btn custom-btn"
            >
              <span className="btn-icon">{slide.customButton.icon}</span>
              {slide.customButton.text}
            </Link>

            <Link
              to={slide.readyButton.link}
              className="btn btn-light px-4 py-2 fw-semibold hero-btn ready-btn"
            >
              <span className="btn-icon">{slide.readyButton.icon}</span>
              {slide.readyButton.text}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
